module.exports = __webpack_public_path__ + "img/2022-3.033b99b1.jpg";